export { default } from './AssignDepartmentHandlers.js';